'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$() {
  this.aQT = null;
  this.aQU = false;
  this.aQV = null;
  this.aQW = false;
  this.aQN = null;
  this.aQO = false;
  this.aQP = null;
  this.aQQ = false;
  this.aQR = null;
  this.aQS = false;
  this.aQX = null;
  this.aQY = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$.prototype = $p;
$p.aA = (function() {
  if ((!this.aQU)) {
    this.aQT = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate$Newtype$$anon$2(this);
    this.aQU = true;
  }
  return this.aQT;
});
$p.t1 = (function() {
  if ((!this.aQW)) {
    this.aQV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate$Newtype$$anon$4(this);
    this.aQW = true;
  }
  return this.aQV;
});
$p.bW = (function() {
  if ((!this.aQO)) {
    this.aQN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aQO = true;
  }
  return this.aQN;
});
$p.jh = (function() {
  if ((!this.aQQ)) {
    this.aQP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lalleycats_Empty$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => {
      var e$proxy8 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$().iu(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_data_FrameworkDate$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_FrameworkPlatform$().ag0())));
      matchResult38: {
        var $x_1;
        if ((e$proxy8 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
          throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), (("Expected Right, got Left(" + e$proxy8.bj) + ")"));
        }
        if ((e$proxy8 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
          var ev$4 = e$proxy8.aI;
          var $x_1 = ((ev$4 === null) ? null : ev$4.cs);
          break matchResult38;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(e$proxy8);
      }
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate($x_1);
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Empty$());
    this.aQQ = true;
  }
  return this.aQP;
});
$p.E9 = (function() {
  if ((!this.aQS)) {
    this.aQR = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Shipment Date";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aQS = true;
  }
  return this.aQR;
});
$p.aY = (function() {
  if ((!this.aQY)) {
    this.aQX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().Cc;
    this.aQY = true;
  }
  return this.aQX;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$, "app.data.data_point_types$package$ShipmentDate$", ({
  Gs: 1,
  B: 1,
  C: 1,
  f0: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipmentDate$ };
//# sourceMappingURL=app.data.data_point_types$package$-Shipment-Date$.js.map
